export class ElementAlreadyExistsError extends Error {
  constructor(msg: string) {
    super(msg)
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, ElementAlreadyExistsError.prototype)
  }
}
